import { graphql } from 'src/gql';

export const ClientPortalOwnTasksQuery = graphql(/* GraphQL */ `
  query ClientPortalOwnTasks {
    tasks {
      id
    }
  }
`);
